import React, { useEffect, useState } from 'react'
import moment from "moment";
import { api } from '../constants/api';
import getHeaders from '../utils/getHeaders';
import { Buffer } from "buffer";

const UpcomingEvents = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [data, setData] = useState([])

    const getUpcomingEvents = async () => {
        let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        try {
            setLoading(true);
            setError('');
            let response = await api(false, `/upcomingEvents?currentTime=${currentTime}`, 'get', {}, { ...getHeaders() });
            setLoading(false);
            const data = response.data.data.map((event: any) => {
                if (event.selectedFile !== null) {
                    return {
                        ...event,
                        date: moment(event.date).format('YYYY-MM-DD'),
                        selectedFile: Buffer.from(event.selectedFile.data)
                    }
                } else {
                    return {
                        ...event,
                        date: moment(event.date).format('YYYY-MM-DD')
                    }
                }
            }) || [];
            setData(data);
        } catch (error: any) {
            console.log(error, '<=== error while fetching upcoming events');
            setLoading(false)
            setError(error?.response?.data?.message || error.message)
            setData([])
        }
    }

    useEffect(() => {
        getUpcomingEvents();
    }, [])

    return (
        <div className="basePriceContainer">
            <h1 className="h1header basePrice">Events</h1>
            {error && (
                <p style={{ color: 'red' }}>{error}</p>
            )}

            <div className="table-responsive">
            <table className="tbl styled-table" border={1}>
                <thead>
                    <tr>
                        <th style={{minWidth: 50}}>
                            #
                        </th>
                        <th style={{minWidth: 200}}>
                            Title
                        </th>
                        <th style={{minWidth: 200}}>
                            Description
                        </th>
                        <th style={{minWidth: 100}}>Date</th>
                        <th style={{minWidth: 100}}>StartTime</th>
                        <th style={{minWidth: 100}}>EndTime</th>
                        <th style={{minWidth: 100}}>SelectedFile</th>
                    </tr>
                </thead>
                <tbody style={{height: 30}}>
                    {loading && (
                        <tr>
                            <td colSpan={2}>
                                Loading...
                            </td>
                        </tr>
                    )}
                    {!loading && (
                        data.map((item: any) => (
                            <tr key={item.id}>
                                <td>
                                    {item.id}
                                </td>
                                <td>
                                    {item.title}
                                </td>
                                <td>{item.desc}</td>
                                <td>{item.date}</td>
                                <td>{item.startTime}</td>
                                <td>{item.endTime}</td>
                                <td>{item.selectedFile !== null ? <a href={item.selectedFile} download={true}> Download </a> : ''}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            </div>
        </div>
    )
}

export default UpcomingEvents
